var $$URLSearchParams = {};
export { $$URLSearchParams };
/* No side effect */